export default __webpack_public_path__ + "static/Aayushi-89e7249fbdd3e70225408d605fd376fb.jpg";